import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {LoginPage} from './login';
import {TranslateModule} from "@ngx-translate/core";
import {DirectivesModule} from "../../directives/directives.module";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
    LoginPage
  ],
  imports: [
    HeaderTitleComponentModule,
    DirectivesModule,
    IonicPageModule.forChild(LoginPage),
    TranslateModule.forChild(),
    PipesModule
  ],
})
export class LoginPageModule {

}



// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts